var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCircleInfo = function SvgIconCircleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z",
    fill: "currentColour"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10Zm-1 4.997c0-.55.448-.997 1-.997s1 .447 1 .997v.499c0 .55-.448.997-1 .997s-1-.446-1-.997v-.499Zm-2 3.49c0 .552.448.998 1 .998h1v3.99h-1c-.552 0-1 .446-1 .997 0 .55.448.997 1 .997h4c.552 0 1-.446 1-.997a.999.999 0 0 0-1-.998h-1v-4.986a.999.999 0 0 0-1-.997h-2c-.552 0-1 .446-1 .997Z",
    fill: "#fff"
  })));
};
export default SvgIconCircleInfo;